<template>
    <div class="wrapper">
        <notifications></notifications>
        <side-bar>
            <template slot-scope="props" slot="links">
                <!-- Pinned menu section (issue #r11-sidebar-pin): menus the
                     user pinned via preferences move up here, out of their
                     normal position. Role guards still apply first.
                     Pinned parents that have a submenu (e.g. "จัดการสมาชิก",
                     "รายงาน") render as a full collapsible menu with their
                     role-filtered children — same shape as the normal
                     position — instead of collapsing into a single link. -->
                <template v-if="pinnedMenuItems.length">
                    <li class="nav-item sidebar-section-title">
                        <span class="nav-link-text">{{ $t('menu.pinned_section') }}</span>
                    </li>
                    <sidebar-item
                        v-for="pin in pinnedMenuItems"
                        :key="'pinned-' + pin.key"
                        :link="{ name: pin.name, icon: pin.icon, path: pin.path }"
                    >
                        <sidebar-item
                            v-for="child in pin.children"
                            :key="'pinned-' + pin.key + '-' + child.key"
                            :link="{ name: $t(child.i18n), path: child.path }"
                        >
                            <sidebar-item
                                v-for="grandchild in (child.children || [])"
                                :key="'pinned-' + pin.key + '-' + child.key + '-' + grandchild.key"
                                :link="{ name: $t(grandchild.i18n), path: grandchild.path }"
                            >
                            </sidebar-item>
                        </sidebar-item>
                    </sidebar-item>
                    <li class="nav-item sidebar-section-divider">
                        <hr class="my-2" />
                    </li>
                </template>

                <sidebar-item
                    :link="{
                        name: menu_dashboard,
                        icon: 'fa fa-chart-pie text-primary',
                        path: '/backoffice/reports/dashboard'
                    }"
                    v-if="(isAccessPayment || isAccessDashboardByPlatformChannel) && menuShow('menu_dashboard')"
                >
                    <sidebar-item :link="{ name: menu_dashboard_team, icon: 'fa fa-users text-primary', path: '/backoffice/reports/dashboard' }" v-if="isAccessPayment" > </sidebar-item>
                    <sidebar-item :link="{ name: menu_dashboard_platform, icon: 'fa fa-chart-bar text-primary', path: '/backoffice/reports/dashboard-by-platform-channel' }" v-if="isAccessDashboardByPlatformChannel" > </sidebar-item>
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order_form,
                        icon: 'fa fa-shopping-cart text-blue',
                        path: '/backoffice/orders/create'
                    }"
                    v-if="isAccessOrder && menuShow('menu_order_form')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order,
                        icon: 'fa fa-tasks text-primary',
                        path: '/backoffice/orders'
                    }"
                    v-if="isAccessOrder && menuShow('menu_order')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order_new,
                        icon: 'fa fa-list-alt text-info',
                        path: '/backoffice/orders-overview'
                    }"
                    v-if="isAccessOrder && isMdfStaff && isAccessOrderOverview && menuShow('menu_order_new')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order_reprocess,
                        icon: 'fa fa-sync text-warning',
                        path: '/backoffice/orders/reprocess'
                    }"
                    v-if="isAdmin && menuShow('menu_order_reprocess')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_available_stock,
                        icon: 'fa fa-cubes text-info',
                        path: '/backoffice/available-stock'
                    }"
                    v-if="isAccessOrder && menuShow('menu_available_stock')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_payment,
                        icon: '	fab fa-btc text-red',
                        path: '/backoffice/payments'
                    }"
                    v-if="isAccessPayment && menuShow('menu_payment')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_packing,
                        icon: 'fa fa-car text-primary',
                        path: '/backoffice/packings'
                    }"
                    v-if="isAccessPacking && menuShow('menu_packing')"
                >
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_order_return,
                        icon: 'fa fa-car text-red',
                        path: '/backoffice/packings/shipping/return'
                    }"
                    v-if="isAccessOrderReturn && menuShow('menu_order_return')"
                >
                </sidebar-item>

				<!-- <sidebar-item
                    :link="{
                        name: 'Return V3 (Webcam)',
                        icon: 'fa fa-video-camera text-orange',
                        path: '/backoffice/packings/shipping/returnv3'
                    }"
                    v-if="isAccessOrderReturn"
                >
                </sidebar-item> -->


				<!-- <sidebar-item
                    :link="{
                        name: menu_customer,
                        icon: 'fa fa-user text-green',
                        path: '/backoffice/customers'
                    }"
                    v-if="isAccessCustomer"
                >
                </sidebar-item> -->

                <!-- <sidebar-item
                    :link="{
                        name: menu_po,
                        icon: 'fa fa-list-alt',
                        path: '/backoffice/po'
                    }"
                    v-if="isAccessPO"
                >
                </sidebar-item> -->

                <sidebar-item
                    :link="{
                        name: menu_coupon,
                        icon: 'fa fa-columns',
                        path: '/backoffice/coupon'
                    }"
                    v-if="isAccessCoupon && menuShow('menu_coupon')"
                >
                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: menu_platform_statement,
                        icon: 'fa fa-file-invoice text-success',
                        path: '/backoffice/platform-statement'
                    }"
                    v-if="isAccessPlatformStatement && menuShow('menu_platform_statement')"
                >
                    <sidebar-item :link="{ name: menu_platform_statement_list, icon: 'fa fa-list', path: '/backoffice/platform-statement' }" v-if="isAccessPlatformStatement" > </sidebar-item>
                    <sidebar-item :link="{ name: menu_platform_statement_upload, icon: 'fa fa-upload', path: '/backoffice/platform-statement/upload' }" v-if="isAccessPlatformStatement" > </sidebar-item>
                    <sidebar-item :link="{ name: menu_platform_statement_summary, icon: 'fa fa-chart-bar', path: '/backoffice/platform-statement/summary' }" v-if="isAccessPlatformStatement" > </sidebar-item>
                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: menu_report,
                        icon: 'fa fa-file text-info',
                        path: '/backoffice/reports'
                    }"
                    v-if="isAccessReport && menuShow('menu_report')"
                >
					<sidebar-item :link="{ name: menu_report_team, icon: 'fa fa-file text-info', path: '/backoffice/reports/team' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_sale_chnanel, icon: 'fa fa-file text-info', path: '/backoffice/reports/sale-channel' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/product' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_user, icon: 'fa fa-file text-info', path: '/backoffice/reports/user' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_user_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/user-product' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_wms_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_wms_product_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms-product' }" v-if="isAccessReport" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_wms_field_summary, icon: 'fa fa-file text-info', path: '/backoffice/reports/summary-wms-field' }" v-if="isAccessReport" > </sidebar-item>
					<!-- "รายงานค่าคอมมิชชั่นตัวแทน" ถูกถอดออกจากเมนูตามคำสั่ง (2026-08-21) — route /backoffice/reports/commission ยังอยู่ -->
					<sidebar-item :link="{ name: menu_report_salechannel_product, icon: 'fa fa-file text-info', path: '/backoffice/reports/salechannel-product' }" v-if="isAccessReport && canViewCost" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_product_cost, icon: 'fa fa-file text-info', path: '/backoffice/reports/product-cost' }" v-if="isAccessReport && canViewCost" > </sidebar-item>
					<sidebar-item :link="{ name: menu_report_order_return, icon: 'fa fa-file text-info', path: '/backoffice/reports/order-return' }" v-if="isAccessReport" > </sidebar-item>

                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: menu_platform,
                        icon: 'fa fa-database text-info',
                        path: '/platform/tiktok'
                    }"
                    v-if="isAccessPlatform && menuShow('menu_platform')"
                >
                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: menu_inventory,
                        icon: 'fa fa-database text-info',
                        path: '/wms/inventory'
                    }"
                    v-if="isAccessWms && menuShow('menu_inventory')"
                >
                    <sidebar-item
                        :link="{
                            name: menu_inventory_dashboard,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/dashboard'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_inventory_list,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/summary'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: menu_inventory_list_detail,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/detail'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: menu_inventory_history,
                            icon: 'fa fa-bullhorn text-info',
                            path: '/wms/history'
                        }"
                        v-if="IsEmployee"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_inventory_history_storage_list,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/storage'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_inventory_summary_packing,
                            icon: 'fa fa-database text-info',
                            path: '/wms/inventory/packing'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_return_warehouse,
                            icon: 'fa fa-undo text-info',
                            path: '/wms/inventory/return'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: menu_partner,
                            icon: 'fa fa-id-card text-blue',
                            path: '/wms/partner'
                        }"
                        v-if="isAdmin"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: menu_product,
                            icon: 'fa fa-cube text-red',
                            path: '/wms/product'
                        }"
                        v-if="isAdmin"
                    >
                    </sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_product_wait_ship,
                            icon: 'fa fa-cube text-red',
                            path: '/wms/product/waitship'
                        }"
                        v-if="IsEmployee"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: menu_storage,
                            icon: 'fa fa-tasks text-primary',
                            path: '/wms/storage'
                        }"
                        v-if="isAdmin"
                    >
                    </sidebar-item>
                    <!-- #437 — last child, same as menu_inventory_shipped_no_deduct in menu-config.js -->
                    <sidebar-item
                        :link="{
                            name: menu_shipped_no_deduct,
                            icon: 'fa fa-truck text-warning',
                            path: '/wms/inventory/shipped-no-deduct'
                        }"
                        v-if="isAccessWms"
                    >
                    </sidebar-item>
                </sidebar-item>

				<sidebar-item
                    :link="{
                        name: menu_express,
                        icon: 'fa fa-cars text-error',
                        path: '/express'
                    }"
                    v-if="isAccessExpress && menuShow('menu_express')"
                >

					<sidebar-item
                        :link="{
                            name: menu_express_list,
                            icon: 'fa fa-tasks text-primary',
                            path: '/express'
                        }"
                        v-if="isAccessExpress"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_express_form,
                            icon: 'fa fa-tasks text-primary',
                            path: '/wms/storage'
                        }"
                        v-if="isAccessExpress"
                    >
					</sidebar-item>

				</sidebar-item>

				<sidebar-item
                        :link="{
                            name: menu_admin,
                            icon: 'fa fa-tasks text-primary',
                            path: '/admin'
                        }"
                        v-if="isAdmin && menuShow('menu_admin')"
                    >
					<sidebar-item
                        :link="{
                            name: menu_user,
                            icon: 'fa fa-tasks text-primary',
                            path: '/admin/user'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>
					<sidebar-item
                        :link="{
                            name: menu_platform_connect,
                            path: '/admin/platform'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_sale_channel,
                            path: '/admin/sale-channel'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_admin_product,
                            path: '/admin/product'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_admin_product_v2,
                            path: '/admin/product_platform'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_available_product,
                            path: '/wms/available-product'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_admin_skurandom,
                            path: '/admin/skurandom'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_payment_channel,
                            path: '/admin/payment'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_shipping_config,
                            icon: 'fa fa-truck text-primary',
                            path: '/backoffice/shipping-config'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>




					<!-- <sidebar-item
                        :link="{
                            name: menu_coupon,
                            path: '/admin/coupon'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item> -->

					<sidebar-item
                        :link="{
                            name: menu_stock_forecast,
                            path: '/wms/forecast'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

					<sidebar-item
                        :link="{
                            name: menu_stock_usage,
                            path: '/wms/usage'
                        }"
                        v-if="isAdmin"
                    >
					</sidebar-item>

                    </sidebar-item>

				<sidebar-item
					:link="{
						name: menu_account,
						icon: 'fa fa-calculator text-success',
						path: '/account'
					}"
					v-if="isAccessAccount && menuShow('menu_account')"
				>
					<sidebar-item
						:link="{
							name: menu_account_records,
							icon: 'fa fa-list',
							path: '/account/records'
						}"
						v-if="isAccessAccount"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_account_items,
							icon: 'fa fa-tags',
							path: '/account/items'
						}"
						v-if="isAccessAccount"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_account_reports,
							icon: 'fa fa-chart-bar',
							path: '/account/reports'
						}"
						v-if="isAccessAccount"
					>
					</sidebar-item>
				</sidebar-item>

			<sidebar-item
				:link="{
					name: menu_member_admin,
					icon: 'fa fa-id-badge text-info'
				}"
				v-if="(isAccessMember || isAdmin) && menuShow('menu_member_admin')"
			>
				<sidebar-item
					:link="{
						name: menu_member_admin_list,
						path: '/members'
					}"
					v-if="isAccessMember"
				>
				</sidebar-item>
				<sidebar-item
					:link="{
						name: menu_member_levels,
						path: '/members/levels'
					}"
					v-if="isAdmin"
				>
				</sidebar-item>
				<!-- COD-rejection anti-abuse guard (issue #179) -->
				<sidebar-item
					:link="{
						name: menu_cod_rejections,
						path: '/members/cod-rejections'
					}"
					v-if="isAdmin"
				>
				</sidebar-item>
				<!-- #169: แจ้งเตือนโปรโมชั่น (broadcast ถึง member; route /notification/promo — D10) -->
				<sidebar-item
					:link="{
						name: menu_promo_notification,
						path: '/notification/promo'
					}"
					v-if="isAdmin"
				>
				</sidebar-item>
				<!-- coin D3-4: รายงาน coin ค้าง (liability) — mirrors
				     menu_member_coins_report in src/util/menu-config.js -->
				<sidebar-item
					:link="{
						name: menu_member_coins_report,
						path: '/members/coins-report'
					}"
					v-if="isAccessMember"
				>
				</sidebar-item>
			</sidebar-item>

			<sidebar-item
				:link="{
					name: menu_kol,
					icon: 'fa fa-star text-warning',
					path: '/kol'
				}"
				v-if="isAccessKOL && menuShow('menu_kol')"
			>
				<sidebar-item
					:link="{
						name: menu_kol_creators,
						path: '/kol/creators'
					}"
					v-if="isAccessKOL"
				>
				</sidebar-item>
				<sidebar-item
					:link="{
						name: menu_kol_assignments,
						path: '/kol/assignments'
					}"
					v-if="isAccessKOL"
				>
				</sidebar-item>
				<sidebar-item
					:link="{
						name: menu_kol_reports,
						path: '/kol/reports'
					}"
					v-if="isAccessKOL"
				>
				</sidebar-item>
				<sidebar-item
					:link="{
						name: menu_kol_payout_batches,
						path: '/kol/payout-batches'
					}"
					v-if="isAccessKOL"
				>
				</sidebar-item>
			</sidebar-item>

			<!-- เมนู "ค่าคอมตัวแทน" ถูกถอดออกจาก sidebar ตามคำสั่ง (2026-08-21)
			     route /backoffice/agent-commission/* ยังอยู่ เข้าตรงด้วย URL ได้ -->

			<sidebar-item
					:link="{
						name: menu_seller,
						icon: 'fa fa-store text-info',
						path: '/seller'
					}"
					v-if="(isSeller || isAdmin) && menuShow('menu_seller')"
				>
					<!-- สินค้า / ตั้งค่าร้านค้า moved to the Seller Center app (owner
					     2026-10-20); mirrored in src/util/menu-config.js. Routes stay. -->
					<sidebar-item
						:link="{
							name: menu_seller_orders,
							path: '/seller/orders'
						}"
						v-if="isSeller || isAdmin"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_seller_payment_report,
							path: '/seller/payment-report'
						}"
						v-if="isSeller || isAdmin"
					>
					</sidebar-item>
				</sidebar-item>

			<sidebar-item
					:link="{
						name: menu_modern_trade,
						icon: 'ni ni-building text-teal',
						path: '/modern-trade/companies'
					}"
					v-if="isAccessModernTrade && menuShow('menu_modern_trade')"
				>
					<!-- ขั้นตอนงาน: ใบสั่งซื้อ (PO) → นำเข้าการขาย → ใบกำกับภาษี · Settings/Reports จัดกลุ่มย่อย -->
					<sidebar-item
						:link="{
							name: menu_mt_sale_orders,
							path: '/modern-trade/sale-orders'
						}"
						v-if="isAccessModernTrade"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_mt_sales_import,
							path: '/modern-trade/sales-import'
						}"
						v-if="isAccessModernTrade"
					>
					</sidebar-item>
					<!-- ฝากขาย: รับเงินผูกกับบริษัทคู่ค้า แล้วออกใบกำกับทีหลัง (spec 2026-08-13) -->
					<sidebar-item
						:link="{
							name: menu_mt_consignment_payments,
							path: '/modern-trade/consignment-payments'
						}"
						v-if="isAccessModernTrade"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_mt_invoices,
							path: '/modern-trade/invoices'
						}"
						v-if="isAccessModernTrade"
					>
					</sidebar-item>
					<!-- #162: ย้าย "คลังสินค้า MT" มาไว้ใต้ "ใบกำกับภาษี" (ระดับเดียวกัน) -->
					<sidebar-item
						:link="{
							name: menu_mt_stock,
							path: '/modern-trade/stock'
						}"
						v-if="isAccessModernTrade"
					>
					</sidebar-item>
					<sidebar-item
						:link="{ name: menu_mt_settings }"
						:menu="true"
						v-if="isAccessModernTrade"
					>
						<sidebar-item
							:link="{
								name: menu_mt_products,
								path: '/modern-trade/products'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_mt_price_templates,
								path: '/modern-trade/price-templates'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_mt_companies,
								path: '/modern-trade/companies'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
						<!-- #166: ตั้งค่ารูปแบบเอกสาร -->
						<sidebar-item
							:link="{
								name: menu_mt_doc_format,
								path: '/modern-trade/doc-format-settings'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
					</sidebar-item>
					<sidebar-item
						:link="{ name: menu_mt_reports }"
						:menu="true"
						v-if="isAccessModernTrade"
					>
						<sidebar-item
							:link="{
								name: menu_mt_report_sales,
								path: '/modern-trade/reports/sales'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_mt_report_stock_value,
								path: '/modern-trade/reports/stock-value'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_mt_expiry_report,
								path: '/modern-trade/expiry-report'
							}"
							v-if="isAccessModernTrade"
						>
						</sidebar-item>
					</sidebar-item>
				</sidebar-item>

				<!-- POS หน้าร้าน (§13.1): roles.pos_bo → bills + reports; + level 2 → devices; + level 4 → events / products / settings -->
				<sidebar-item
					:link="{
						name: menu_pos,
						icon: 'ni ni-cart text-pink',
						path: '/pos/bills'
					}"
					v-if="isPosBO && menuShow('menu_pos')"
				>
					<sidebar-item
						:link="{
							name: menu_pos_bills,
							path: '/pos/bills'
						}"
						v-if="isPosBO"
					>
					</sidebar-item>
					<sidebar-item
						:link="{ name: menu_pos_reports }"
						:menu="true"
						v-if="isPosBO"
					>
						<sidebar-item
							:link="{
								name: menu_pos_report_sales,
								path: '/pos/reports/sales'
							}"
							v-if="isPosBO"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_report_top_spenders,
								path: '/pos/reports/top-spenders'
							}"
							v-if="isPosBO"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_report_products,
								path: '/pos/reports/products'
							}"
							v-if="isPosBO"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_report_promotions,
								path: '/pos/reports/promotions'
							}"
							v-if="isPosBO"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_report_event_members,
								path: '/pos/reports/event-members'
							}"
							v-if="isPosBO"
						>
						</sidebar-item>
					</sidebar-item>
					<sidebar-item
						:link="{ name: menu_pos_settings_group }"
						:menu="true"
						v-if="isPosBOSupervisor"
					>
						<sidebar-item
							:link="{
								name: menu_pos_devices,
								path: '/pos/devices'
							}"
							v-if="isPosBOSupervisor"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_events,
								path: '/pos/events'
							}"
							v-if="isPosBOAdmin"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_bundles,
								path: '/pos/products'
							}"
							v-if="isPosBOAdmin"
						>
						</sidebar-item>
						<sidebar-item
							:link="{
								name: menu_pos_settings,
								path: '/pos/settings'
							}"
							v-if="isPosBOAdmin"
						>
						</sidebar-item>
					</sidebar-item>
				</sidebar-item>

				<!-- การตลาด (Phase 1 ads §6.1): หน้า Landing (โฆษณา) + ที่มาของออเดอร์ -->
				<sidebar-item
					:link="{
						name: menu_marketing,
						icon: 'fa fa-bullhorn text-orange',
						path: marketingPath
					}"
					v-if="(isAccessMarketing || isAccessAffiliateFinance) && menuShow('menu_marketing')"
				>
					<sidebar-item
						:link="{
							name: menu_marketing_landing_pages,
							path: '/marketing/landing-pages'
						}"
						v-if="isAccessMarketing"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_marketing_attribution,
							path: '/marketing/reports/attribution'
						}"
						v-if="isAccessMarketing"
					>
					</sidebar-item>
					<!-- Phase 2 referral §5.1: appended after the source report -->
					<sidebar-item
						:link="{
							name: menu_marketing_referral_codes,
							path: '/marketing/referral-codes'
						}"
						v-if="isAccessMarketing"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_marketing_referral_report,
							path: '/marketing/reports/referral'
						}"
						v-if="isAccessMarketing"
					>
					</sidebar-item>
					<!-- Phase 3 affiliate §5.1: appended after the referral report -->
					<sidebar-item
						:link="{
							name: menu_marketing_affiliate_settings,
							path: '/marketing/affiliate/settings'
						}"
						v-if="isAccessMarketing"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_marketing_affiliate_members,
							path: '/marketing/affiliate/members'
						}"
						v-if="isAccessMarketing || isAccessAffiliateFinance"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_marketing_affiliate_commissions,
							path: '/marketing/affiliate/commissions'
						}"
						v-if="isAccessMarketing || isAccessAffiliateFinance"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_marketing_affiliate_payouts,
							path: '/marketing/affiliate/payouts'
						}"
						v-if="isAccessAffiliateFinance"
					>
					</sidebar-item>
					<sidebar-item
						:link="{
							name: menu_marketing_affiliate_report,
							path: '/marketing/reports/affiliate'
						}"
						v-if="isAccessMarketing || isAccessAffiliateFinance"
					>
					</sidebar-item>
				</sidebar-item>

                <!-- เมนู "แจ้งปัญหา" และ "เวอร์ชัน / Releases" ถูกถอดออกจาก sidebar ตามคำสั่ง (2026-08-21)
                     route /admin/issue-reports และ /admin/releases ยังอยู่ เข้าตรงด้วย URL ได้ -->

            </template>
        </side-bar>
        <div class="main-content">
            <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

            <div class="main-content__page" @click="$sidebar.displaySidebar(false)">
                <fade-transition
                    :duration="200"
                    origin="center top"
                    mode="out-in"
                >
                    <!-- your content here -->
                    <!-- keep-alive: components named in keepAliveList preserve
                         their state (data / scroll) across navigation. MemberList
                         always (detail -> Back restores page / q / status / rows),
                         and since 2026-10-06 every page that has a tab open in the
                         taskbar, one instance PER TAB: the router-view is keyed by
                         the tab's key, which keep-alive uses as its cache key.
                         docs/specs/2026-10-06-bo-taskbar-fill-keepalive-design.md §3 -->
                    <keep-alive :include="keepAliveList" :max="keepAliveMax">
                        <router-view :key="viewKey"></router-view>
                    </keep-alive>
                </fade-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
		console.log("New perfect scroolbar",className)
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
		console.log("try to init it later in case ",className)
        setTimeout(() => {
            initScrollbar(className);
        }, 2000);
    }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";
import { taskbarKey, taskbarIsPage, TASKBAR_MAX_TABS } from "@/utils/taskbar";
import { taskbarLive } from "@/utils/taskbarLive";
import { keepAliveInclude, keepAliveOptedOut, evictOrDefer, stillClosed, removedKeys, findKeepAlive } from "@/utils/keepAlive";

// Kept alive whether or not it has a tab — the behaviour before the taskbar.
const ALWAYS_KEEP_ALIVE = ["MemberList"];

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        DashboardContent,
        FadeTransition
    },
    data() {
        return {
            // Component names listed here keep their instance alive across
            // route navigation — preserves state (page, filters, scroll, rows)
            // when the user navigates to a detail page and clicks Back.
            //
            // Stays DATA with MemberList as its literal seed (the blind control
            // suite pins both); the keepAliveWanted watcher below keeps it in
            // step with the taskbar's open tabs.
            keepAliveList: ["MemberList"],
            // A backstop only. The real limit is the taskbar's: closing or
            // evicting a tab destroys its instance (liveTabs watcher). The +2
            // leaves room for the page on screen before its tab exists and for
            // MemberList without a tab.
            keepAliveMax: TASKBAR_MAX_TABS + 2,
        };
    },
    computed: {
        // keep-alive's cache key. A taskbar page is keyed like its tab, so two
        // tabs of one component (product A / product B, orders ?status=141 /
        // ?status=143) are two instances (B2). Anything else — including a
        // page that opts out with meta.keepAlive === false (B7) — by fullPath.
        viewKey() {
            return taskbarIsPage(this.$route) && !keepAliveOptedOut(this.$route) ? taskbarKey(this.$route) : this.$route.fullPath;
        },
        liveTabs() {
            return taskbarLive.tabs;
        },
        // Every open tab's component name, the page on screen (B6), and
        // MemberList. Decided in src/utils/keepAlive.js.
        keepAliveWanted() {
            const names = keepAliveInclude(
                taskbarLive.tabs,
                this.$route,
                p => this.$router.resolve(p).route,
                taskbarLive.components
            );
            for (const name of ALWAYS_KEEP_ALIVE) {
                if (!names.includes(name)) names.push(name);
            }
            return names;
        },
        menu_po: function() {
            return this.$t("menu.po");
        },

        menu_user: function() {
            return this.$t("menu.user");
        },

        menu_admin: function() {
            return this.$t("menu.admin");
        },

		menu_platform_connect: function() {
            return this.$t("menu.admin_platform_connect");
        },

        menu_shipping_config: function() {
            return this.$t("shipping_config.menu");
        },

        // ==========================================================
        // Backoffice Module
        // ==========================================================
		menu_order_form : function() {
			return this.$t("order_form");
		},
        menu_order_new: function() {
            return this.$t("orders_new.title");
        },
        menu_order: function() {
            return this.$t("orders");
        },
        menu_order_reprocess: function() {
            return this.$t("reprocess.title");
        },

        menu_available_stock: function() {
            return this.$t("wms.menu.available_product");
        },


        menu_payment: function() {
            return this.$t("payment_check");
        },

		menu_payment_agent: function() {
            return this.$t("payment_check") + " (ตัวแทน)";
        },


        menu_payment_channel: function() {
            return this.$t("payment_channel");
        },

		menu_coupon: function() {
			return this.$t("coupon");
		},

        menu_packing: function() {
            return this.$t("packings");
        },
		menu_order_return: function() {
            return this.$t("order_return");
        },


		menu_customer: function() {
			return this.$t("customer_information");
		},

        menu_report: function() {
            return this.$t("reports");
        },

		menu_report_salechannel_product: function(){
            return this.$t("report_by_sale_channel_and_product");
		},

		menu_report_product_cost: function(){
            return this.$t("report_product_cost");
		},

		menu_report_team: function() {
			return this.$t("report_by_team");
		},

		menu_report_sale_chnanel: function() {
			return this.$t("report_by_sale_channel");
		},

		menu_report_product: function() {
			return this.$t("report_by_product");
		},

		menu_report_user: function() {
			return this.$t("report_by_user");
		},

		menu_report_user_product: function() {
			return this.$t("report_by_user_product");
		},

		menu_report_wms_summary: function() {
			return this.$t("report_wms_summary");
		},

		menu_report_wms_product_summary: function() {
			return this.$t("report_wms_product_summary");
		},
		menu_report_wms_field_summary: function() {
			return this.$t("report_wms_field_summary");
		},
		menu_report_order_return: function() {
			return this.$t("report_order_return");
		},
		menu_dashboard: function() {
			return this.$t("menu_dashboard");
		},
		menu_dashboard_team: function() {
			return this.$t("menu_dashboard_team");
		},
		menu_dashboard_platform: function() {
			return this.$t("menu_dashboard_platform");
		},

		// Platform Statement
		menu_platform_statement: function() {
			return this.$t("platform_statement.menu");
		},
		menu_platform_statement_list: function() {
			return this.$t("platform_statement.list");
		},
		menu_platform_statement_upload: function() {
			return this.$t("platform_statement.upload");
		},
		menu_platform_statement_summary: function() {
			return this.$t("platform_statement.summary");
		},

        menu_platfrom: function() {
            return this.$t("platform_connect");
        },

		menu_admin_product: function() {
			return this.$t("menu.admin_product");
		},

		menu_admin_product_v2: function() {
			return this.$t("menu.admin_product_v2");
		},

		menu_available_product: function() {
			return this.$t("wms.menu.available_product");
		},

		menu_admin_skurandom: function() {
			return this.$t("menu.admin_skurandom");
		},

        // ==========================================================
        // WMS Module
        // ==========================================================
        menu_inventory_history: function() {
            return this.$t("wms.menu.inventory_history");
        },
		menu_inventory_summary_packing: function(){
            return this.$t("wms.menu.inventory_summary_packing");
		},
		menu_return_warehouse: function(){
            return this.$t("wms.menu.return_warehouse");
		},
        menu_promotion: function() {
            return this.$t("wms.menu.promotion");
        },
		menu_inventory_dashboard: function() {
            return this.$t("wms.menu.inventory_dashboard");
        },
        menu_inventory_list: function() {
            return this.$t("wms.menu.inventory_list");
        },
        menu_inventory_list_detail: function() {
            return this.$t("wms.menu.inventory_list_detail");
        },
        menu_inventory: function() {
            return this.$t("wms.menu.inventory");
        },
		menu_inventory_history_storage_list: function(){
			return this.$t("wms.menu.inventory_history_storage_list");
		},
        menu_partner: function() {
            return this.$t("wms.menu.partner");
        },
        menu_product: function() {
            return this.$t("wms.menu.product");
        },
        menu_product_v2: function() {
            return this.$t("wms.menu.product_v2");
        },
		menu_product_wait_ship: function(){
			return "สินค้ารอส่ง"
		},
        menu_storage: function() {
            return this.$t("wms.menu.storage");
        },
        menu_shipped_no_deduct: function() {
            return this.$t("wms.menu.shipped_no_deduct");
        },

		menu_sale_channel: function() {
            return this.$t("menu.sale_channel");
        },

		menu_stock_usage: function() {
			return this.$t("usage.title");
		},
		menu_stock_forecast: function() {
			return this.$t("forecast.title");
		},

		// ==========================================================
		// KOL Module
		// ==========================================================
		menu_kol: function() {
			return this.$t("kol.name");
		},
		menu_kol_creators: function() {
			return this.$t("kol.menu.creators");
		},
		menu_kol_assignments: function() {
			return this.$t("kol.menu.assignments");
		},
		menu_kol_reports: function() {
			return this.$t("kol.menu.reports");
		},
		menu_kol_payout_batches: function() {
			return this.$t("kol.menu.payout_batches");
		},
		menu_member_admin: function() {
			return this.$t("member_admin.title");
		},
		menu_member_admin_list: function() {
			return this.$t("member_admin.list_title");
		},
		menu_member_levels: function() {
			return this.$t("member_level.title");
		},
		menu_cod_rejections: function() {
			return this.$t("cod_rejections.menu");
		},
		// coin D3-4 liability report
		menu_member_coins_report: function() {
			return this.$t("menu.member_coins_report");
		},

		// ==========================================================
		// Account Module
		// ==========================================================
		menu_account: function() {
			return this.$t("account.name");
		},
		menu_account_items: function() {
			return this.$t("account.menu.items");
		},
		menu_account_records: function() {
			return this.$t("account.menu.records");
		},
		menu_account_reports: function() {
			return this.$t("account.menu.reports");
		},

		// ==========================================================
		// Agent Commission Module
		// ==========================================================

		menu_seller: function() {
			return this.$t("menu.seller");
		},
		menu_seller_orders: function() {
			return this.$t("menu.seller_orders");
		},
		menu_seller_payment_report: function() {
			return this.$t("menu.seller_payment_report");
		},

		// ==========================================================
		// Modern Trade Module
		// ==========================================================
		menu_modern_trade: function() {
			return this.$t("modern_trade.name");
		},
		menu_mt_companies: function() {
			return this.$t("modern_trade.menu.companies");
		},
		menu_mt_receipts: function() {
			return this.$t("modern_trade.menu.receipts");
		},
		menu_mt_sales_import: function() {
			return this.$t("modern_trade.menu.sales_import");
		},
		menu_mt_stock: function() {
			return this.$t("modern_trade.menu.stock");
		},
		menu_mt_expiry_report: function() {
			return this.$t("modern_trade.menu.expiry_report");
		},
		menu_mt_products: function() {
			return this.$t("modern_trade.menu.products");
		},
		menu_mt_price_templates: function() {
			return this.$t("modern_trade.menu.price_templates");
		},
		menu_mt_sale_orders: function() {
			return this.$t("modern_trade.menu.sale_orders");
		},
		menu_mt_invoices: function() {
			return this.$t("modern_trade.menu.invoices");
		},
		menu_mt_consignment_payments: function() {
			return this.$t("modern_trade.menu.consignment_payments");
		},
		menu_mt_report_sales: function() {
			return this.$t("modern_trade.menu.report_sales");
		},
		menu_mt_report_stock_value: function() {
			return this.$t("modern_trade.menu.report_stock_value");
		},
		menu_mt_settings: function() {
			return this.$t("modern_trade.menu.settings");
		},
		menu_mt_reports: function() {
			return this.$t("modern_trade.menu.reports");
		},
		menu_mt_doc_format: function() {
			return this.$t("modern_trade.menu.doc_format");
		},
		// ==========================================================
		// POS หน้าร้าน (#443)
		// ==========================================================
		menu_pos: function() {
			return this.$t("pos.menu.root");
		},
		menu_pos_bills: function() {
			return this.$t("pos.menu.bills");
		},
		menu_pos_reports: function() {
			return this.$t("pos.menu.reports");
		},
		menu_pos_report_sales: function() {
			return this.$t("pos.menu.report_sales");
		},
		menu_pos_report_top_spenders: function() {
			return this.$t("pos.menu.report_top_spenders");
		},
		menu_pos_report_products: function() {
			return this.$t("pos.menu.report_products");
		},
		menu_pos_report_promotions: function() {
			return this.$t("pos.menu.report_promotions");
		},
		menu_pos_report_event_members: function() {
			return this.$t("pos.menu.report_event_members");
		},
		menu_pos_settings_group: function() {
			return this.$t("pos.menu.manage");
		},
		menu_pos_devices: function() {
			return this.$t("pos.menu.devices");
		},
		menu_pos_events: function() {
			return this.$t("pos.menu.events");
		},
		menu_pos_bundles: function() {
			return this.$t("pos.menu.products");
		},
		menu_pos_settings: function() {
			return this.$t("pos.menu.settings");
		},
		// การตลาด (Phase 1 ads)
		menu_marketing: function() {
			return this.$t("marketing.menu.root");
		},
		// Phase 3 (verifier B #3): a finance-only user would bounce off the
		// landing-page list — the parent opens the affiliate members page.
		marketingPath: function() {
			return this.isAccessMarketing ? "/marketing/landing-pages" : "/marketing/affiliate/members";
		},
		menu_marketing_landing_pages: function() {
			return this.$t("marketing.menu.landing_pages");
		},
		menu_marketing_attribution: function() {
			return this.$t("marketing.menu.attribution");
		},
		menu_marketing_referral_codes: function() {
			return this.$t("marketing.menu.referral_codes");
		},
		menu_marketing_referral_report: function() {
			return this.$t("marketing.menu.referral_report");
		},
		// Phase 3 affiliate
		menu_marketing_affiliate_settings: function() {
			return this.$t("marketing.menu.affiliate_settings");
		},
		menu_marketing_affiliate_members: function() {
			return this.$t("marketing.menu.affiliate_members");
		},
		menu_marketing_affiliate_commissions: function() {
			return this.$t("marketing.menu.affiliate_commissions");
		},
		menu_marketing_affiliate_payouts: function() {
			return this.$t("marketing.menu.affiliate_payouts");
		},
		menu_marketing_affiliate_report: function() {
			return this.$t("marketing.menu.affiliate_report");
		},
		menu_promo_notification: function() {
			return this.$t("promo_notification.title");
		},
		// เมนูขนส่งด่วน: template อ้าง 3 ตัวนี้มาตลอดแต่ไม่เคยมี computed จริง
		// (ชื่อเมนูเลยว่าง) และ list ของ pin/ซ่อนก็ชี้ key `shipping_type_express`
		// ที่ไม่มีในไฟล์ภาษา — ใช้ menu_pref.* ที่มีคำแปลอยู่แล้วทั้ง th/en
		menu_express: function() {
			return this.$t("menu_pref.express");
		},
		menu_express_list: function() {
			return this.$t("menu_pref.express_list");
		},
		menu_express_form: function() {
			return this.$t("menu_pref.express_form");
		},

		// ==========================================================
		// Menu preferences (hide / pin) — issue #r11-sidebar-pin
		// Consumes the `menuPref` Vuex module (Dev-BO-C). The module may
		// not be registered yet; every accessor below is fail-safe and
		// falls back to "show everything, pin nothing".
		// ==========================================================
		// Ordered metadata for every top-level, pinnable menu.
		// `key` MUST match the key convention in src/util/menu-config.js
		// (Dev-BO-C's single source of truth, PR #132) — the `menu_*`
		// identifier — so a key the settings page writes into `pinned` /
		// `hidden` resolves to the same menu here. `name` reuses the
		// existing i18n getters so
		// labels stay DRY. `permitted` mirrors the role guard on the normal
		// menu item — role filtering ALWAYS runs first (a preference can
		// only hide more, never grant access beyond the user's role).
		topMenuDefs: function() {
			return [
				{ key: 'menu_dashboard', name: this.menu_dashboard, icon: 'fa fa-chart-pie text-primary', path: '/backoffice/reports/dashboard', permitted: this.isAccessPayment || this.isAccessDashboardByPlatformChannel },
				{ key: 'menu_order_form', name: this.menu_order_form, icon: 'fa fa-shopping-cart text-blue', path: '/backoffice/orders/create', permitted: this.isAccessOrder },
				{ key: 'menu_order', name: this.menu_order, icon: 'fa fa-tasks text-primary', path: '/backoffice/orders', permitted: this.isAccessOrder },
				{ key: 'menu_order_reprocess', name: this.menu_order_reprocess, icon: 'fa fa-sync text-warning', path: '/backoffice/orders/reprocess', permitted: this.isAdmin },
				{ key: 'menu_available_stock', name: this.menu_available_stock, icon: 'fa fa-cubes text-info', path: '/backoffice/available-stock', permitted: this.isAccessOrder },
				{ key: 'menu_payment', name: this.menu_payment, icon: 'fab fa-btc text-red', path: '/backoffice/payments', permitted: this.isAccessPayment },
				{ key: 'menu_packing', name: this.menu_packing, icon: 'fa fa-car text-primary', path: '/backoffice/packings', permitted: this.isAccessPacking },
				{ key: 'menu_order_return', name: this.menu_order_return, icon: 'fa fa-car text-red', path: '/backoffice/packings/shipping/return', permitted: this.isAccessOrderReturn },
				{ key: 'menu_coupon', name: this.menu_coupon, icon: 'fa fa-columns', path: '/backoffice/coupon', permitted: this.isAccessCoupon },
				{ key: 'menu_platform_statement', name: this.menu_platform_statement, icon: 'fa fa-file-invoice text-success', path: '/backoffice/platform-statement', permitted: this.isAccessPlatformStatement },
				{ key: 'menu_report', name: this.menu_report, icon: 'fa fa-file text-info', path: '/backoffice/reports', permitted: this.isAccessReport },
				{ key: 'menu_platform', name: this.$t('platform_connect'), icon: 'fa fa-database text-info', path: '/platform/tiktok', permitted: this.isAccessPlatform },
				{ key: 'menu_inventory', name: this.menu_inventory, icon: 'fa fa-database text-info', path: '/wms/inventory', permitted: this.isAccessWms },
				{ key: 'menu_express', name: this.menu_express, icon: 'fa fa-cars text-error', path: '/express', permitted: this.isAccessExpress },
				{ key: 'menu_admin', name: this.menu_admin, icon: 'fa fa-tasks text-primary', path: '/admin', permitted: this.isAdmin },
				{ key: 'menu_account', name: this.menu_account, icon: 'fa fa-calculator text-success', path: '/account', permitted: this.isAccessAccount },
				{ key: 'menu_member_admin', name: this.menu_member_admin, icon: 'fa fa-id-badge text-info', path: '/members', permitted: this.isAccessMember || this.isAdmin },
				{ key: 'menu_kol', name: this.menu_kol, icon: 'fa fa-star text-warning', path: '/kol', permitted: this.isAccessKOL },
				{ key: 'menu_seller', name: this.menu_seller, icon: 'fa fa-store text-info', path: '/seller', permitted: this.isSeller || this.isAdmin },
				{ key: 'menu_modern_trade', name: this.menu_modern_trade, icon: 'ni ni-building text-teal', path: '/modern-trade/companies', permitted: this.isAccessModernTrade },
				{ key: 'menu_pos', name: this.menu_pos, icon: 'ni ni-cart text-pink', path: '/pos/bills', permitted: this.isPosBO },
				{ key: 'menu_marketing', name: this.menu_marketing, icon: 'fa fa-bullhorn text-orange', path: this.marketingPath, permitted: this.isAccessMarketing || this.isAccessAffiliateFinance },
			];
		},
		// menuPref/visibleTree = MENU_TREE (src/util/menu-config.js) filtered
		// down to what the current user is permitted to see, using the SAME
		// Auth/* getters the normal-position v-if guards rely on. This is
		// how the pinned section gets each pinned parent's full, role-
		// filtered submenu instead of collapsing it into a single link.
		// Fail-safe: module absent / getter error => no submenus (parent
		// still renders as a plain link via `permitted`, same as before).
		visibleMenuTree: function() {
			if (!this.hasMenuPref()) return [];
			try {
				return this.$store.getters['menuPref/visibleTree'] || [];
			} catch (e) {
				return [];
			}
		},
		// Items rendered in the top "Pinned Menu" section: pinned AND still
		// permitted by role. Order follows topMenuDefs. `children` (already
		// role-filtered) is attached so pinned parents with submenus render
		// as a collapsible menu instead of losing their children (bo-stg
		// feedback: pinning "จัดการสมาชิก"/"รายงาน" hid their submenu).
		pinnedMenuItems: function() {
			const tree = this.visibleMenuTree;
			return this.topMenuDefs
				.filter(m => m.permitted && this.isMenuPinned(m.key))
				.map(m => {
					const node = tree.find(n => n.key === m.key);
					return {
						key: m.key,
						name: m.name,
						icon: m.icon,
						path: m.path,
						children: (node && node.children) || []
					};
				});
		},

        ...mapGetters({
            getUser: "Auth/getUser",
            isAccessWms: "Auth/isAccessWms",
            isAccessTiktok: "Auth/isAccessTiktok",
            isAccessOrder: "Auth/isAccessOrder",
            isAccessProduct: "Auth/isAccessProduct",
            isAccessPacking: "Auth/isAccessPacking",
            isAccessReport: "Auth/isAccessReport",
            isAccessPayment: "Auth/isAccessPayment",
            isAccessPlatformStatement: "Auth/isAccessPlatformStatement",
            isAccessPlatform: "Auth/isAccessPlatform",
            isAccessDelivery: "Auth/isAccessDelivery",
			isAccessCustomer:  "Auth/isAccessCustomer",
			isAccessExpress: "Auth/isAccessExpress",
			isAccessOrderReturn: "Auth/isAccessOrderReturn",
            isAccessPO: "Auth/isAccessPO",
            isAccessCoupon: "Auth/isAccessCoupon",
			isAccessAccount: "Auth/isAccessAccount",
			isAccessKOL: "Auth/isAccessKOL",
			isAccessMember: "Auth/isAccessMember",
			isAdmin:  "Auth/isAdmin",
			isAccessDashboardByPlatformChannel: "Auth/isAccessDashboardByPlatformChannel",
			isAccessAgentCommission: "Auth/isAccessAgentCommission",
			isSeller: "Auth/isSeller",
			isAccessModernTrade: "Auth/isAccessModernTrade",
			isEditModernTrade: "Auth/isEditModernTrade",
			isAccessShippingConfig: "Auth/isAccessShippingConfig",
			isAccessShippingConfigWrite: "Auth/isAccessShippingConfigWrite",
			isPosSeller: "Auth/isPosSeller",
			isPosSupervisor: "Auth/isPosSupervisor",
			isPosAdmin: "Auth/isPosAdmin",
			isPosBO: "Auth/isPosBO",
			isPosBOSupervisor: "Auth/isPosBOSupervisor",
			isPosBOAdmin: "Auth/isPosBOAdmin",
			canViewCost: "Auth/canViewCost",
			isMdfStaff: "Auth/isMdfStaff",
			isAccessOrderOverview: "Auth/isAccessOrderOverview",
			isAccessMarketing: "Auth/isAccessMarketing",
			isAccessAffiliateFinance: "Auth/isAccessAffiliateFinance"
        })
    },
    watch: {
        keepAliveWanted: {
            immediate: true,
            handler(list) {
                if (list.join("\n") !== this.keepAliveList.join("\n")) this.keepAliveList = list.slice();
            }
        },
        // A tab closed ("ปิด", "ปิดแท็บอื่น", "ปิดทั้งหมด", or pushed out by the
        // cap) drops its instance now, so reopening it loads fresh (B3). An
        // empty strip — logout — drops every instance left (B4).
        //
        // The page ON SCREEN cannot be destroyed under the user's feet, so its
        // key waits in pendingEvictions until the navigation PageTaskbar makes
        // after a close has moved off it (flushEvictions, from the $route
        // watcher and updated()). A logout leaves the layout altogether, and
        // keep-alive destroys whatever it still holds on its way out.
        liveTabs(next, prev) {
            // Found by walking the render tree, not $refs: Vue 2 drops `ref`
            // from an abstract component such as <keep-alive> (findKeepAlive).
            const keepAlive = findKeepAlive(this._vnode);
            if (!keepAlive) return;
            const gone = next && next.length ? removedKeys(prev, next) : (keepAlive.keys || []).slice();
            this.pendingEvictions = evictOrDefer(keepAlive, stillClosed(this.pendingEvictions.concat(gone), next));
        },
        $route() {
            this.$nextTick(this.flushEvictions);
        }
    },
    methods: {
        // Evict the closed tabs' instances that were on screen when their tab
        // closed, now that they are not (or keep waiting if they still are).
        flushEvictions() {
            if (!this.pendingEvictions || !this.pendingEvictions.length) return;
            const keepAlive = findKeepAlive(this._vnode);
            if (!keepAlive) return;
            this.pendingEvictions = evictOrDefer(keepAlive, stillClosed(this.pendingEvictions, taskbarLive.tabs));
        },
        ...mapActions({
            setUser: "Auth/setUser",
            IsEmployee: "Auth/IsEmployee",
            IsReadonly: "Auth/IsReadonly"
        }),
        initScrollbar() {
            let isWindows = navigator.platform.startsWith("Win");
            if (isWindows) {
                initScrollbar("sidenav");
            }
        },
		// ---- Menu preference helpers -----------------------------------
		// These consume the `menuPref` module (Dev-BO-C, PR #132) at runtime
		// via getters — no build-time import, so this component still
		// compiles/renders normally if that module is not present yet.
		hasMenuPref() {
			return !!(this.$store && this.$store.hasModule && this.$store.hasModule("menuPref"));
		},
		// True if the user pinned this menu.
		isMenuPinned(key) {
			if (!this.hasMenuPref()) return false;
			try {
				return !!this.$store.getters["menuPref/isMenuPinned"](key);
			} catch (e) {
				return false;
			}
		},
		// Whether a menu should render in its NORMAL position. We defer the
		// show/hide decision to the module's isMenuShown getter (pin wins ->
		// hidden hides -> default shown) and additionally exclude pinned
		// items, since those are rendered in the top pinned section instead
		// (moved up, not duplicated).
		// Fail-safe: module absent / any error => show the menu.
		menuShow(key) {
			if (!this.hasMenuPref()) return true;
			try {
				return !!this.$store.getters["menuPref/isMenuShown"](key)
					&& !this.$store.getters["menuPref/isMenuPinned"](key);
			} catch (e) {
				return true;
			}
		},
		// Load the user's menu preferences once, on layout mount.
		// Fail-safe: any error (module absent, request failure) leaves all
		// menus visible and nothing pinned (the module itself also fails open).
		loadMenuPrefs() {
			try {
				if (this.hasMenuPref()) {
					const p = this.$store.dispatch("menuPref/load");
					if (p && typeof p.catch === "function") {
						p.catch(() => {});
					}
				}
			} catch (e) {
				// swallow — sidebar falls back to showing every menu
			}
		}
    },
    created() {
        // Not reactive on purpose: nothing renders from it.
        this.pendingEvictions = [];
    },
    updated() {
        this.flushEvictions();
    },
    mounted() {
        this.initScrollbar();
        this.loadMenuPrefs();
    }
};
</script>
<style lang="scss">
/* docs/specs/2026-10-07-bo-layout-sticky-footer-fixed-canvas-design.md
   §3.1 the html/body gradient, fixed to the viewport (here too, so a hard reload
   of a dashboard page has it without AuthLayout's chunk) */
@import "~@/assets/sass/custom/app-canvas";

/* #416 F3: shared `.bon-table` el-table rules (fixed-right ⋮ column opaque + header
   aligned) for OrdersNew.vue and /wms/product — the only import. */
@import "~@/assets/sass/custom/bon-table";

/* §3.2 footer at the bottom of the viewport on short pages: navbar / page / footer
   are a column at least one viewport tall; the page grows, the footer sits last.
   `.wrapper >` keeps it on this layout: AuthLayout (login) also renders a
   .main-content, and this global block stays loaded after logout. */
.wrapper > .main-content {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.wrapper > .main-content > .main-content__page {
    flex: 1 0 auto;
}
.wrapper > .main-content > .footer {
    margin-top: auto;
    flex: 0 0 auto;
}

.text-app {
    color: #19aaf8;
}

/* Pinned menu section (issue #r11-sidebar-pin) */
.sidebar-section-title {
    padding: 0.5rem 1.5rem 0.25rem;
    list-style: none;

    .nav-link-text {
        font-size: 0.7rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        /* was #8898aa = 2.95:1 on the white sidebar, at 0.7rem uppercase.
           Same value $text-muted now carries: #607286 = 4.94:1. */
        color: #607286;
    }
}
.sidebar-section-divider {
    list-style: none;
    padding: 0 1.5rem;

    hr {
        border-top: 1px solid #e9ecef;
    }
}
</style>
